// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import * as ToolsAPI from "./tools.mjs";
import { Tools } from "./tools.mjs";
import { buildHeaders } from "../../internal/headers.mjs";
import { path } from "../../internal/utils/path.mjs";
export class McpServers extends APIResource {
    constructor() {
        super(...arguments);
        this.tools = new ToolsAPI.Tools(this._client);
    }
    /**
     * Add a new MCP server to the Letta MCP server config
     */
    create(body, options) {
        return this._client.post('/v1/mcp-servers/', { body, ...options });
    }
    /**
     * Get a specific MCP server
     */
    retrieve(mcpServerID, options) {
        return this._client.get(path `/v1/mcp-servers/${mcpServerID}`, options);
    }
    /**
     * Update an existing MCP server configuration
     */
    update(mcpServerID, body, options) {
        return this._client.patch(path `/v1/mcp-servers/${mcpServerID}`, { body, ...options });
    }
    /**
     * Get a list of all configured MCP servers
     */
    list(options) {
        return this._client.get('/v1/mcp-servers/', options);
    }
    /**
     * Delete an MCP server by its ID
     */
    delete(mcpServerID, options) {
        return this._client.delete(path `/v1/mcp-servers/${mcpServerID}`, {
            ...options,
            headers: buildHeaders([{ Accept: '*/*' }, options?.headers]),
        });
    }
    /**
     * Refresh tools for an MCP server by:
     *
     * 1. Fetching current tools from the MCP server
     * 2. Deleting tools that no longer exist on the server
     * 3. Updating schemas for existing tools
     * 4. Adding new tools from the server
     *
     * Returns a summary of changes made.
     */
    refresh(mcpServerID, params = {}, options) {
        const { agent_id } = params ?? {};
        return this._client.patch(path `/v1/mcp-servers/${mcpServerID}/refresh`, {
            query: { agent_id },
            ...options,
        });
    }
}
McpServers.Tools = Tools;
//# sourceMappingURL=mcp-servers.mjs.map